import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import axios from "axios";
import { link } from "../../config";

const languages = [
  {
    code: "en",
    name: "English",
    country_code: "gb",
  },
  {
    code: "ar",
    name: "العربية",
    dir: "rtl",
    country_code: "kw",
  },
];

function NavTop() {
  const { t } = useTranslation();
  const [index, setIndex] = useState(0);
  const [list, setList] = useState([]); // Holds the fetched header list
  const [listItem, setListItem] = useState("");
  const [active, setActive] = useState(i18next.language || "ar"); // Initialize with i18next language or default

  // Fetch headers from API
  const getHeaders = async () => {
    try {
      const { data } = await axios.get(`${link}web-config`);
      const headers = data.websiteHeader || [];
      setList(headers);
      setListItem(headers[0]?.[active] || ""); // Initialize with the first header
    } catch (error) {
      console.error("Error fetching headers:", error);
    }
  };

  // Change displayed text periodically
  useEffect(() => {
    if (list.length > 0) {
      const interval = setInterval(() => {
        setIndex((prevIndex) => {
          const nextIndex = (prevIndex + 1) % list.length;
          setListItem(list[nextIndex]?.[active] || "");
          return nextIndex;
        });
      }, 3000); // Change every 3 seconds

      return () => clearInterval(interval); // Cleanup on unmount
    }
  }, [list, active]);

  useEffect(() => {
    getHeaders();
  }, []);

  // Change language and update the document language and other states
  const handleLanguageChange = (code) => {
    i18next.changeLanguage(code);
    setActive(code); // Update the active language
  };

  useEffect(() => {
    document.getElementsByTagName("html")[0].setAttribute("lang", i18next.language);
  }, [active]);

  return (
    <div className="top-nav d-flex align-items-center">
      <div className="container d-flex justify-content-between align-items-start">
        <div
          className="d-flex center align-items-start"
          style={{ direction: active === "ar" ? "rtl" : "ltr" }}
        >
          <p className="m-0">{listItem}</p>
        </div>
        <div className="right d-flex gap-2 align-items-center">
          {languages.map(({ code, name, country_code }) => (
            <label
              key={country_code}
              className={`${active === code ? "active" : ""}`} // Apply 'active' class based on the current language
            >
              <input
                type="radio"
                name="language"
                value={code}
                onChange={() => handleLanguageChange(code)}
                className="d-none"
              />
              {name}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}

export default NavTop;
